jQuery(document).ready(function ($) {


  const slickOptions = {
    mobileFirst: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  };
  $(window).resize(function () {
    if ($(window).width() < 768) {
      $(".product__media-list__container--large").slick(slickOptions);
    } else {
      //$(".product__media-list__container--large").slick("unslick");
    }
  });

  $(".product__media-list__container--large").slick(slickOptions);

  $('.pills-variant-labels').on('click', function(e) {
    const w = window.innerWidth;
    if (w < 768) {
      //e.preventDefault();
      const media_id = $(this).attr('data-media-id');
      const item = $('div[data-media-id$="__main-'+media_id+'"]');
      const parent = $(item).closest('.slick-slide');
      const index = $(parent).attr('data-slick-index');
      console.log(index);
      $(".product__media-list__container--large").slick("goTo", index);
    }

  })

  $('[data-out-of-stock="true"]').map((i, v) => $(v).attr('data-media-id')).each((i, item) => $('div[data-media-id$="__main-'+item+'"]').addClass('hidden'));
});
